<template>
  <div class="ccs-layout">
    <div class="ccs-layout ccs-12 ccs-layout--no-pad">
      <ccs-input class="ccs-12" v-model.trim="fieldsValues.name" v-bind="fieldsDefinitions.name"
        @error="(err) => setFieldError('name', err)"/>
      <ccs-input class="ccs-5" v-model.trim="fieldsValues.email" v-bind="fieldsDefinitions.email"
        @error="(err) => setFieldError('email', err)"/>
      <ccs-input class="ccs-5" v-model.trim="fieldsValues.phone" v-bind="fieldsDefinitions.phone"
        @error="(err) => setFieldError('phone', err)"/>
      <ccs-input class="ccs-2" type="file" label="Логотип"
        v-model="file" accept=".jpeg,.jpg,.png"/>
      <ccs-input class="ccs-4" v-model.trim="fieldsValues.last_name"
        v-bind="fieldsDefinitions.last_name" @error="(err) => setFieldError('last_name', err)"/>
      <ccs-input class="ccs-4" v-model.trim="fieldsValues.first_name"
        v-bind="fieldsDefinitions.first_name" @error="(err) => setFieldError('first_name', err)"/>
      <ccs-input class="ccs-4" v-model.trim="fieldsValues.patronymic"
        v-bind="fieldsDefinitions.patronymic" @error="(err) => setFieldError('patronymic', err)"/>
    </div>
    <div class="ccs-layout ccs-layout--no-pad">
      <div>
        <button class="ccs-button" @click="submit">
          Сохранить и добавить
        </button>
      </div>
      <div>
        <button class="ccs-button ccs-button--light" @click="$emit('close')">
          Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import FormHelper from '@/mixins/FormHelper.js';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'Package',
  mixins: [FormHelper],
  components: {
    'ccs-input': Input,
  },
  data() {
    return {
      fieldsDefinitions: {
        name: {
          isValid: false,
          error: '',
          required: true,
          type: "text",
          label: "Название спонсора",
          placeholder: "Введите название",
        },
        phone: {
          isValid: false,
          error: '',
          required: false,
          type: "text",
          label: "Номер телефона",
          placeholder: "Введите номер телефона",
        },
        email: {
          isValid: false,
          error: '',
          required: false,
          type: "text",
          label: "Email",
          placeholder: "Введите email",
        },
        first_name: {
          isValid: false,
          error: '',
          required: false,
          type: "text",
          label: "Имя",
          placeholder: "Введите имя",
        },
        last_name: {
          isValid: false,
          error: '',
          required: false,
          type: "text",
          label: "Фамилия",
          placeholder: "Введите фамилию",
        },
        patronymic: {
          isValid: false,
          error: '',
          required: false,
          type: "text",
          label: "Отчество",
          placeholder: "Введите отчество",
        },
      },
      fieldsValues: {
        name: '',
        phone: '',
        email: '',
        first_name: '',
        last_name: '',
        patronymic: '',
      },
      file: null,
    };
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return undefined;
      },
    },
  },
  computed: {
    fileURL() {
      return this.file ? URL.createObjectURL(this.file) : '';
    },
  },
  methods: {
    ...mapActions('session', ['uploadFile', 'replaceFile', 'deleteFile']),
    ...mapActions('sponsors', ['getSponsors', 'createSponsor', 'updateSponsor']),
    async submit() {
      this.validateForm();
      if (this.isFormValid) {
        if (this.fieldsValues.id) {
          await this.editSponsor();
        } else {
          await this.addSponsor();
        }
      }
    },
    async addSponsor() {
      try {
        const sponsorID = await this.createSponsor(this.fieldsValues);
        this.$toasted.success('Спонсор добавлен');
        if (this.file) {
          const result = await this.uploadFile({
            file: this.file,
            entityID: sponsorID,
            entityType: 'sponsors',
            fileType: 'logo',
          });
          this.getSponsors();
          this.$toasted.success('Логотип добавлен');
        }
        this.$emit('close');
      } catch (err) {
        this.showServerValidationErrors(err);
      }
    },
    async editSponsor() {
      try {
        const changedFields = this.getChangedFields(this.$props.data);
        if (Object.keys(changedFields).length > 0){
          await this.updateSponsor({
            ...changedFields,
            id: this.fieldsValues.id,
          });
          this.$toasted.success('Изменения сохранены');
        }
        if (this.file) {
          if (this.$props.data.files.data && this.$props.data.files.data[0]) {
            await this.replaceFile({
              file: this.file,
              fileID: this.$props.data.files.data[0].id,
            });
            this.getSponsors();
            this.$toasted.success('Логотип изменен');
          } else {
            await this.uploadFile({
              file: this.file,
              entityID: this.fieldsValues.id,
              entityType: 'sponsors',
              fileType: 'logo',
            });
            this.getSponsors();
            this.$toasted.success('Логотип добавлен');
          }
        }
        this.$emit('close');
      } catch (err) {
        this.showServerValidationErrors(err);
      }
    },
  },
  created() {
    if (this.$props.data && this.$props.data.id) {
      this.fieldsValues = Object.assign({}, this.$props.data);
    }
  },
}
</script>

<style lang="scss" scoped>
</style>